<template>
  <Modal
    :open="props.open"
    @close-modal="$emit('close-modal')"
    custom-height="h-[75vh]"
    :hide-footer="true"
  >
    <template #modal-header>
      <div class="flex flex-col">
        <div class="flex gap-2 items-center">
          <Icon name="Pencil" class="h-4 w-4 text-success" />
          <p class="font-inter text-sm text-success font-semibold">Reinvestment</p>
        </div>
        <h3 class="font-semibold text-[28px] text-strongest">Select investment</h3>
      </div>
    </template>
    <template #modal-body>
      <div class="p-6">
        <Table
          :table_headers="rollover_table_headers"
          :table_data="rollover_table_data"
          variant="secondary"
          :has_actions="true"
          :fields_with_custom_styles="['maturity_date', 'rollover_available']"
          mobile_primary_field="rollover_available"
          :column_gap_px="20"
        >
          <template v-slot:rollover_available="entry">
            <div>
              <p class="font-medium text-success">
                {{ formatCurrency(entry.row.rollover_available) }}
              </p>
            </div>
          </template>
          <!-- <template v-slot:maturity_date="entry">
            <div>
              {{
                Math.max(
                  0,
                  Math.floor(
                    (new Date(entry.row.maturity_date) - new Date()) / (1000 * 60 * 60 * 24)
                  )
                )
              }}
              days
            </div>
          </template> -->
          <template v-slot:actions="entry">
            <div>
              <Button variant="primary-grey" @click="selectRollover(entry.row)">
                <template #label> Reinvest </template>
              </Button>
            </div>
          </template>
        </Table>
      </div>
    </template>
  </Modal>
</template>

<script setup>
import { computed } from "vue";
import { Modal, Icon, Table, Button } from "@/components";
import { usePurchaseFlowStore } from "@/stores";

const purchaseFlowStore = usePurchaseFlowStore();

let rollover_table_headers = [
  {
    label: "Available for Reinvestment",
    field_name: "rollover_available",
    field_type: "number",
    number_type: "currency",
  },
  {
    label: "Amount at maturity",
    field_name: "amount_at_maturity",
    field_type: "number",
    number_type: "currency",
  },
  { label: "Time Until Maturity", field_name: "time_until_maturity", field_type: "text" },
  { label: "Type", field_name: "type" },
  {
    label: "Amount Reinvested",
    field_name: "amount_reinvested",
    field_type: "number",
    number_type: "currency",
  },
];

const rollover_table_data = computed(() => {
  let data = purchaseFlowStore.rolloverGetter.investments_for_rollover || [];

  data.forEach((entry) => {
    // calculate time until maturity for each rollover
    const maturityDate = new Date(entry.maturity_date);
    const now = new Date();
    if (isNaN(maturityDate.getTime())) {
      entry.time_until_maturity = "-";
    } else {
      const timeDiff = maturityDate - now;
      if (timeDiff > 0) {
        entry.time_until_maturity = Math.ceil(timeDiff / (1000 * 60 * 60 * 24)) + " days";
      } else {
        entry.time_until_maturity = "Matured";
      }
    }
  });
  return data;
});

const emit = defineEmits(["close-modal"]);
const props = defineProps({
  open: { type: Boolean, required: true },
});

function selectRollover(row) {
  purchaseFlowStore.selected_rollover = row;
  purchaseFlowStore.current_investment.amount = row.rollover_available;
  emit("close-modal");
}

function formatCurrency(value) {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);
}
</script>
